document.addEventListener('DOMContentLoaded', () => {
    handleApparelClothingThemeSettings();
});

function setANC(type) {
    if (type === "sorority" || type === "fraternity") {
        sessionStorage.setItem("navANC", type);
        return;
    }
    sessionStorage.setItem("navANC", "sorority");
}

function getANC() {
    return sessionStorage.getItem("navANC") || "sorority";
}

function handleApparelClothingThemeSettings() {
    // 1. Target both the Desktop Mega Menu and the Mobile Drawer [cite: 92, 107, 3]
    const menuContainers = document.querySelectorAll(".anc-mega, .anc-drawer");
    if (menuContainers.length === 0) return;

    // 2. Find all toggle buttons within those containers [cite: 111, 112, 116]
    // Use a broader selector that finds the attribute regardless of the tag (button or span)
    const allBtns = [];
    menuContainers.forEach(container => {
        const found = container.querySelectorAll('.anc-toggle');
        allBtns.push(...found);
    });

    // console.log('Total Buttons Found:', allBtns.length); // Should be > 0
    
    if (allBtns.length === 0) return;
    
    initButtons();
    // Set initial state from Session Storage [cite: 115, 119]
    setActive(allBtns, getANC());

    function initButtons() {
        allBtns.forEach((btn) => {
            /* CRITICAL: Use 'true' for the capture phase. 
               This intercepts the click before the theme's 
               MenuDrawer script can close the menu.
            */
           // console.log('initing btn', btn);
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopImmediatePropagation(); // Kill the theme's 'Close' listener [cite: 30, 8]

                const btnType = btn.dataset.greekType;
                const currentStorage = getANC();

                if (currentStorage !== btnType) {
                    setActive(allBtns, btnType);
                }
            }, true); 
        });
    }

    function setActive(btns, type) {
        let prevClass, activeClass;
  
        if (type === "fraternity") {
            prevClass = "active-sorority";
            activeClass = "active-fraternity";
        } else {
            prevClass = "active-fraternity";
            activeClass = "active-sorority";
        }
  
        setANC(type);

        // Update classes on all menu containers simultaneously [cite: 114]
        menuContainers.forEach(container => {
            container.classList.remove(prevClass);
            container.classList.add(activeClass);
        });

        // Update visual button styles [cite: 111, 112]
        btns.forEach((btn) => {
            const isSelected = btn.dataset.greekType === type;
            const colorScheme = btn.dataset.greekType === 'sorority' ? 'color-scheme-7' : 'color-scheme-5';

            if (isSelected) {
                btn.className = `button button--secondary ${colorScheme} anc-toggle`;
                btn.style.opacity = "1";
            } else {
                btn.className = 'button button--tertiary anc-toggle';
                btn.style.opacity = "0.5";
            }
        });
    }
}